import type { RouteRecordRaw } from 'vue-router';

export const discountRoutes: Array<RouteRecordRaw> = [
  {
    path: '/discount',
    name: 'discount',
    redirect: '/discount/list',
    component: () => import('pages/trade/admin/discount/McDiscount.vue'),
    meta: {
      title: 'Discounts',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'discountList',
        component: () => import('pages/trade/admin/discount/DiscountList.vue'),
        meta: {
          title: 'Discounts List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'discountDetail',
        component: () => import('pages/trade/admin/discount/DiscountDetail.vue'),
        meta: {
          title: 'Discount Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'discountNew',
        component: () => import('pages/trade/admin/discount/DiscountNew.vue'),
        meta: {
          title: 'New Discount',
          requiresAuth: true,
        },
      },
    ],
  },
];
